import { SI_ROOT_ROUTE } from "app/common/constants/ad-intelligence-routes";
import { WI_TO_SI_AD_INTEL_ROUTES } from "app/pages/sales-intelligence/constants/wiToSiAdIntelRoutes";

/**
 * Maps an Ad Intelligence target state name onto the mirror owned by the currently mounted
 * solution, leaving it untouched outside Sales Intelligence.
 *
 * Reused Web Intelligence components hardcode native WI state names. Consumers that turn such a
 * name into a URL synchronously (`proNavigator.href`) cannot be given a WI name while SI is
 * mounted: WI children are still unregistered future states on a cold SI load, so `href` falls
 * back to the `*.**` glob and emits a parameterless URL (e.g. `#/advertiseractivity`) that matches
 * no route and drops the user out of SI. SI state names are registered together with the SI module
 * chunk, so resolving them up front keeps the URL complete and the user inside SI.
 */
export const resolveAdIntelRouteForCurrentSolution = (
    targetStateName: string | undefined,
    currentStateName: string | undefined,
): string | undefined => {
    if (!targetStateName || !currentStateName?.startsWith(`${SI_ROOT_ROUTE}-`)) {
        return targetStateName;
    }
    return WI_TO_SI_AD_INTEL_ROUTES[targetStateName] ?? targetStateName;
};
